import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import hashPath from './hashPathDetector.js';
import { us, jp, es, fr, it, mx, oe, de, uk, au, ca, ko } from './locales';
import { getStoreDefaultLocales, geoLanguageLocales, getUserLocationAsync } from '../store-components/utils/StoreConfigManager.js';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(hashPath);

const defaultLanguageResources = {
    'us_en': {
        common: us['en'].common
    },
    'jpn_ja': {
        common: jp['ja'].common
    },
    'esp_es': {
        common: es['es'].common
    },
    'fra_fr': {
        common: fr['fr'].common
    },
    'ita_it': {
        common: it['it'].common
    },
    'mex_es': {
        common: mx['es'].common
    },
    'eu_en': {
        common: oe['en'].common
    },
    'eu_de': {
        common: de['de'].common
    },
    'gb_en': {
        common: uk['en'].common
    },
    'aus_en': {
        common: au['en'].common
    },
    'ca_en': {
        common: ca['en'].common
    }
    ,
    'kor_kr': {
        common: ko['kr'].common
    }
};

// the below locale codes come from ticket 3986
const cookieGdprLocaleCodeMap = {
    'us_en': 'en_31150',
    'jpn_ja': 'ja_32701',
    'esp_es': 'es_31151',
    'fra_fr': 'fr_31152',
    'ita_it': 'it_30150',
    'mex_es': 'es_32150',
    'eu_en': 'en_30650',
    'eu_de': 'de_30650',
    'gb_en': 'en_30151',
    'aus_en': 'en_33751',
    'ca_en': 'en_32650',
    'kor_kr': 'ko_31650'
}

const storeAvailableLanguages = getStoreDefaultLocales();
let defaultLocale = storeAvailableLanguages.length > 0 ? storeAvailableLanguages[0] : ''
getUserLocationAsync()
    .then(data => {
        let lang = window.location.hash.split('/')[1];
        let urlLang = storeAvailableLanguages.includes(lang) ? lang : null;

        const localeSelected = geoLanguageLocales[data.loc.toLowerCase()] || defaultLocale
        defaultLocale = urlLang ? urlLang : (localeSelected ? localeSelected : defaultLocale)

        // START the below locale codes come from ticket 3986
        const firstDiv = document.createElement("div");
        firstDiv.className = "frg17_overlayCookies cc-customdialog";
        firstDiv.style.display = "none";

        const innerP = document.createElement("p");
        innerP.className = "cc_cd_lbl_text1";

        const firstInnerA = document.createElement("a");
        firstInnerA.className = "frg17_closeCookies cc-button-enableall cc_cd_lbl_button_close btn cmp-button cmp-button--md cmp-button--fillblack";
        firstInnerA.href = "#";
        firstInnerA.setAttribute("qa-id", "privacy-dismiss-button");
        firstInnerA.innerText = "I accept";

        const secondInnerA = document.createElement("a");
        secondInnerA.className = "frg17_refuseCookies cc-button-refuseall cc_cd_lbl_button_close btn cmp-button cmp-button--md cmp-button--fillblack";
        secondInnerA.href = "https://www.ferragamo.com/shop/us/en/sf/legal/cookie-policy#cookieSettings";
        secondInnerA.setAttribute("qa-id", "privacy-dismiss-button");
        secondInnerA.innerText = "Manage options";

        firstDiv.appendChild(innerP);
        firstDiv.appendChild(firstInnerA);
        firstDiv.appendChild(secondInnerA);

        const firstCookieScript = document.createElement("script");
        firstCookieScript.src = "https://cdn.ferragamo.com/wcsstore/FerragamoR17SAS/javascript/Custom/r17/lib/jquery.cookie.js";

        document.body.append(firstDiv);
        document.body.append(firstCookieScript);

        const ccSettingsScript = document.createElement("script");
        const fnTextNode = document.createTextNode(
        `var ccSettings = {};

        if (document.getElementsByName('cookie_page').length > 0 && document.getElementsByName('cookie_page')[0].value === "true") {
            ccSettings.settings = {
                messagetype: "none",
                consenttype: "hybrid-allenabled"
            };
        } else {
            ccSettings.settings = {
                privacypage: 'https://www.ferragamo.com/cookie-policy',
                locale: ${JSON.stringify(cookieGdprLocaleCodeMap[defaultLocale])},
                disableClickTrigger: false
            };
        };`);

        ccSettingsScript.appendChild(fnTextNode);


        const secondCookieScript = document.createElement('script');
        secondCookieScript.src = 'https://cdn.ferragamo.com/wcsstore/FerragamoR17SAS/javascript/Custom/r17/lib/cookie/tcl_cookieconsent_i18n.js';
        const thirdCookieScript = document.createElement('script');
        thirdCookieScript.src = 'https://cdn.ferragamo.com/wcsstore/FerragamoR17SAS/javascript/Custom/r17/lib/cookie/tcl_cookieconsent.js';


        document.body.append(ccSettingsScript);
        document.body.append(secondCookieScript);
        document.body.append(thirdCookieScript);
        // END

        console.log("=> locales", defaultLocale, localeSelected, urlLang);

        const options = {
            detection: {
                order: ['hashPath'],
                lookupFromHashPathIndex: 1,
                availableLanguages: storeAvailableLanguages,
                caches: []
            },
            interpolation: {
                escapeValue: false,
            },
            resources: defaultLanguageResources,
            debug: true,
            fallbackLng: storeAvailableLanguages.length > 0 ? storeAvailableLanguages[0] : '',
            lng: defaultLocale,
            lowerCaseLng: true,
            load: 'all',
            ns: ['common'],
            defaultNS: 'common',
            react: {
                wait: false,
                bindI18n: 'languageChanged loaded',
                bindStore: 'added removed',
                nsMode: 'default'
            },
        };
        console.log("=> options", options);
        i18n
            .use(languageDetector)
            .init(options)
    })
    .catch(error => { console.log("error ", error) });

export default i18n;
